import React from 'react';
import PropTypes from 'prop-types';
import { Loc } from 'redux-react-i18n';
import Loader from 'components/mediabay-ui/components/Loader';
import Carousel from 'components/mediabay-ui/components/Carousel';
import ChannelItem from '../ChannelItem';
import CarouselContainer from './common/CarouselContainer';
import CarouselEmpty from './common/CarouselEmpty';

class ChannelsCarousel extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['tv', 'radio']).isRequired,
    getChannels: PropTypes.func.isRequired,
    channelsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    onItemClick: PropTypes.func,
  }

  static defaultProps = {
    onItemClick: null,
  }

  constructor(props) {
    super(props);

    const { channelsData } = this.props;

    this.state = {
      isChannelsFetching: true,
      channelsData,
    };
  }

  componentDidMount() {
    const { getChannels } = this.props;
    getChannels();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      prevState.channelsData.status === 200
      || prevState.channelsData.status !== nextProps.channelsData.status
    ) {
      // Generating 2 rows from channels data
      let channelsPerRow = null;
      const channels = nextProps.channelsData.data.slice(0);
      const radio = [];

      if (channels.length) {
        channelsPerRow = Math.round(channels.length / 2);
      }

      for (let i = 0; i < channelsPerRow; i += 1) {
        radio.push(channels.splice(0, 2));
      }

      return {
        isChannelsFetching: false,
        channelsData: {
          ...nextProps.channelsData,
          data: radio,
        },
      };
    }
    return null;
  }

  render() {
    const { isChannelsFetching, channelsData } = this.state;
    const { type, onItemClick } = this.props;
    let carouselContent = null;

    if (isChannelsFetching) {
      carouselContent = (
        <CarouselEmpty>
          <Loader />
        </CarouselEmpty>
      );
    } else if (isChannelsFetching === false && channelsData.status !== 200) {
      carouselContent = (
        <CarouselEmpty>
          <Loc locKey="loadingError" />
        </CarouselEmpty>
      );
    } else if (channelsData.data.length === 0) {
      carouselContent = (
        <CarouselEmpty>
          <Loc locKey="noChannelsData" />
        </CarouselEmpty>
      );
    } else {
      carouselContent = (
        <Carousel
          childWidth={218}
          containerOffset={65}
        >
          {
            channelsData.data.map((channel, index) => (
              // eslint-disable-next-line
              <div key={index}>
                {
                  channel.map(child => (
                    <ChannelItem
                      key={child.id}
                      data-id={child.id}
                      channelType={type}
                      id={child.id}
                      picture={channelsData.mediaHost + child.logo}
                      title={child.name}
                      isHd={child.hd}
                      countryIcon={channelsData.mediaHost + child.flag}
                      onClick={onItemClick}
                    />
                  ))
                }
              </div>
            ))
          }
        </Carousel>
      );
    }

    return (
      <div>
        <CarouselContainer>
          {carouselContent}
        </CarouselContainer>
      </div>
    );
  }
}

export default ChannelsCarousel;
